<template>
  <div style="height: 100vh;min-height: 685px;">
    <div class="centen">
      <!--用户重置密码-->
      <div class="accountEntry" >
        <h5><i class="el-icon-info"></i> 为了您的账户安全，第一次登录平台需修改您的账户密码</h5>
        <ul>
          <li>
            <span>新密码</span>
            <el-input placeholder="新密码" v-model="newPassword" size="mini" :maxlength=20 type="password"
                      @keyup.13.native="changePassword">
            </el-input>
          </li>
          <li>
            <span>确认密码</span>
            <el-input placeholder="确认密码" v-model="confirmPassword" size="mini" :maxlength=20 type="password"
                      @keyup.13.native="changePassword">
            </el-input>
          </li>
          <li>
            <a @click="changePassword" class="btn">确认</a>
          </li>
        </ul>
      </div>
    </div>
    <footer>Copyright © 2017，Damai-IoT，All Rights Reserved | 浙ICP备18001529号</footer>
  </div>
</template>

<script>
  import md5 from 'js-md5'
  import {bus} from '../utils/bus'
  import {nError, nSuccess} from '../utils/notice'
  import {pattern} from '../utils/regular'
  import {errorHandler} from '../utils/errorHandler'
  import {api} from './api/Login'

  export default {
    name: 'first-change-password',
    data () {
      return {
        accountName: '',
        accountCode: '',
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      }
    },
    created () {
      this.accountName = window.sessionStorage.getItem('accountName')
      this.accountCode = window.sessionStorage.getItem('accountCode')
      let oldPassword = window.sessionStorage.getItem('firstChangeOldPassword')
      if (oldPassword) {
        this.oldPassword = oldPassword
      }
    },
    methods: {
      toLoginPage: function () {
        this.$router.push({
          name: 'login'
        })
      },
      toHomepage () {
        window.sessionStorage.setItem('navTop', 'workbench')
        this.$router.push({
          name: 'workbench'
        })
      },
      toyqInfoPage () {
        let routerName = ''
        window.sessionStorage.setItem('navTop', 'resource')
        if (bus.global.permissionCodes.indexOf('001001000') !== -1) {
          routerName = 'yq-information'
        } else if (bus.global.permissionCodes.indexOf('001002000') !== -1) {
          routerName = 'yq-notice-management'
        } else if (bus.global.permissionCodes.indexOf('001002004') !== -1) {
          routerName = 'yq-video-management'
        } else if (bus.global.permissionCodes.indexOf('001003000') !== -1) {
          routerName = 'housing-management'
        } else if (bus.global.permissionCodes.indexOf('001004000') !== -1) {
          routerName = 'business-management'
        } else if (bus.global.permissionCodes.indexOf('001005000') !== -1) {
          routerName = 'person-management'
        } else if (bus.global.permissionCodes.indexOf('001006000') !== -1) {
          routerName = 'config-card'
        } else if (bus.global.permissionCodes.indexOf('001007000') !== -1) {
          routerName = 'account-management'
        } else if (bus.global.permissionCodes.indexOf('001008000') !== -1) {
          routerName = 'role-management'
        } else if (bus.global.permissionCodes.indexOf('001009000') !== -1) {
          routerName = 'ali-config'
        } else if (bus.global.permissionCodes.indexOf('001009004') !== -1) {
          routerName = 'config-routine'
        } else if (bus.global.permissionCodes.indexOf('001009006') !== -1) {
          routerName = 'config-card-type'
        } else if (bus.global.permissionCodes.indexOf('001010000') !== -1) {
          routerName = 'resource-center-log'
        } else if (bus.global.permissionCodes.indexOf('002001000') !== -1) {
          routerName = 'custom-management'
        } else if (bus.global.permissionCodes.indexOf('003001000') !== -1) {
          routerName = 'accessCtrlDeviceManagementCenter'
        } else if (bus.global.permissionCodes.indexOf('004001000') !== -1) {
          routerName = 'parking-device-management'
        } else if (bus.global.permissionCodes.indexOf('005001000') !== -1) {
          routerName = 'controller-management'
        } else if (bus.global.permissionCodes.indexOf('007004000') !== -1) {
          routerName = 'visitor-device-manage'
        } else if (bus.global.permissionCodes.indexOf('008001000') !== -1) {
          routerName = 'site-management'
        } else if (bus.global.permissionCodes.indexOf('009001000') !== -1) {
          routerName = 'ladder-device'
        } else if (bus.global.permissionCodes.indexOf('011001000') !== -1) {
          routerName = 'repair-category-manage'
        } else if (bus.global.permissionCodes.indexOf('002007000') !== -1) {
          routerName = 'needHandle'
        } else {
          routerName = 'workbench'
        }
        this.$router.push({
          name: routerName
        })
      },
      changePassword () {
        let checkPassword = pattern.password.test(this.newPassword)
        if (!this.newPassword) {
          nError('请输入密码')
          return false
        } else {
          if (!checkPassword) {
            nError('请输入8至20位无特殊字符的密码')
            return false
          }
        }
        if (this.newPassword !== this.confirmPassword) {
          nError('两次密码不一致')
          return false
        }
        let name = this.accountName.toLowerCase()
        let newpw = this.newPassword + name
        let newonce = md5(newpw) + name
        let newpwd
        for (let i = 0; i < 9; i++) {
          newpwd = md5(newonce)
          newonce = newpwd + name
        }
        this.$axios.post(api.changePassword, {
          code: this.accountCode,
          password: this.oldPassword,
          newPassword: newpwd
        })
          .then(res => {
            if (res.data.retCode === 1) {
              nSuccess('修改成功')
              if (bus.global.permissionCodes.indexOf('000000000') === -1) {
                this.toyqInfoPage()
              } else {
                this.toHomepage()
              }
            }
          })
          .catch(errorHandler('修改失败'))
      },
    }
  }
</script>

<style scoped>
  .head img {
    width: 250px;
    height: 44px;
    margin: 15px 10px 15px 30px;
  }
  .centen {
    width: 100%;
    height: 90%;
    background-color: #EFF1F5;
    position: relative;
  }
  .accountEntry {
    width: 480px;
    height: 280px;
    padding: 20px;
    position: absolute;
    top: 120px;
    left: 0;
    right: 0;
    margin: 0 auto;
    background: white;
    border: 1px solid #E6E6E6;
  }

  h5 {
    color: #4D4D4D;
    font-weight: 400;
    margin: 0;
    padding-bottom: 15px;
    border-bottom: 1px solid #eeeeee;
  }

  h5 i {
    color: #00A0E6;
  }

  .code-li .el-input {
    width: 180px;
  }

  .codeImg {
    display: inline-block;
    width: 100px;
    height: 28px;
    margin-left: 10px;
    vertical-align: bottom;
    padding: 5px 10px;
    letter-spacing: 14px;
    background-image: url('../assets/code.jpg');
    background-size: 100% 100%;
  }

  .codeImg:hover {
    cursor: pointer;
  }

  #user_phone {
    margin-left: 10px;
    width: 160px;
    text-align: left;
    color: #00A0E6;
  }

  .accountEntry li {
    padding: 0 33px;
    margin-top: 25px;
    text-align: left;
    display: flex;
    align-items: center;
  }

  .accountEntry li span {
    display: inline-block;
    width: 60px;
    text-align: right;
  }

  .accountEntry li:last-child {
    display: flex;
    justify-content: space-between;
    padding: 0 60px;
  }

  .prompt b {
    display: block;
    width: 100%;
    text-align: center;
    color: red;
    margin-top: 8px;
    margin-bottom: -5px;
  }

  .btn {
    display: block;
    width: 90px;
    margin: 0 auto;
    color: #FFFFFF;
    border-radius: 5px;
    text-align: center;
    background-color: #00A0E6;
    padding: 5px 10px;
  }

  .el-input {
    margin-left: 10px;
    width: 80%;
  }

  footer {
    width: 100%;
    font-size: 13px;
    text-align: center;
    color: #999999;
    background-color: #F0F3F7;
    height: 10vh;
    line-height: 35px;
  }
</style>



// WEBPACK FOOTER //
// src/view/FirstChangePassword.vue